import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiDtgUserService
    ,FvmsApiAuthService
    ,FvmsApiDtgTeamService
} from "src/app/shared/service";
import {
    DtgActionType
    ,PagingInfo
} from "src/app/shared/vo";
import {
    DtgManageCompanySearchComponent
} from "src/app/dtg/manage/company/search/dtg.manage.company.search.component";

@Component({
    templateUrl: "./dtg.manage.driver.form.component.html"
    ,providers: []
})
export class DtgManageDriverFormComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    currentUserInfo:any;
    @Input() companyId:string;
    @Input() userId:string;
    @Input() dtgActionType:DtgActionType;
    formGroup: FormGroup;
    submitted:boolean = false;
    readOnly:boolean = true;
    DtgActionType = DtgActionType;
    listUserGroup:any[];
    listTeam:any[];
    checkSameId:boolean = false;
    userPwReset:string;

    constructor(
        private modalService: NgbModal
        ,public activeModal: NgbActiveModal
        ,private formBuilder: FormBuilder
        ,private fvmsApiDtgUserService:FvmsApiDtgUserService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsApiDtgTeamService:FvmsApiDtgTeamService
    ) {
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
     }

    ngOnInit() {
        this.initForm();
        switch(this.dtgActionType){
            case DtgActionType.create:
                this.readOnly = false;
                this.checkSameId = false;
                break;
            case DtgActionType.update:
            case DtgActionType.delete:
                this.readOnly = false;
                this.checkSameId = true;
                this.selectOneUserInfo();
                break;
            case DtgActionType.read:
            default:
                this.readOnly = true;
                this.checkSameId = true;
                this.selectOneUserInfo();
                this.formGroup.disable();
                break;
        }
        this.getListUserGroup();
        this.getListTeam();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {

    }

    initForm(){
        this.formGroup = this.formBuilder.group({
            userId:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,userNm:null
            ,userPw:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,userBirthDt:null
            ,userHireDt:null
            ,companyId:[
                this.companyId
                ,[
                    Validators.required
                ]
            ]
            ,companyNm:null
            ,userGroupId:[
                "1000"
                ,[
                    Validators.required
                ]
            ]
            ,userGroupNm:null
            ,dtgDriverNm:null
            ,dtgDriverLcsNo:[
                null
                ,[
                    Validators.maxLength(18)
                    ,Validators.pattern("[0-9]{0,18}")
                ]
            ]
            ,drvKotsaDriverId:null
            ,dtgTeamId:null
            ,mobile:null
            ,email:null
            ,memo:null
            ,useYn:"Y"
            ,dtgUnitId:null
            ,dtgCarNo:null
        });
    }

    get f() { return this.formGroup.controls; }

    selectOneUserInfo(){
        let searchInfo = {
            companyId : this.companyId
            ,userId : this.userId
        };
        this.fvmsApiDtgUserService.getOneUser(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    if(apiResponse.resultValue.userPw) {
                        apiResponse.resultValue.userPw = "123456789012345678901234567890";
                    }
                    this.formGroup.patchValue(apiResponse.resultValue);
                }
            });
    }

    // 권한 목록 셀렉트박스
    getListUserGroup(){
        let searchInfo = {
            userGroupId : 1000
        };
        this.fvmsApiDtgUserService.getListUserGroup(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listUserGroup = apiResponse.resultValue;
                }
            });
    }

    // 회사 그룹 셀렉트박스
    getListTeam(){
        let searchInfo = {
            companyId:this.companyId
            ,dtgTeamId:this.currentUserInfo.teamId
        };
        let pagingInfo:PagingInfo = new PagingInfo();
        pagingInfo.pageSize = 1000;
        this.fvmsApiDtgTeamService.getListTeam(searchInfo,pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listTeam = apiResponse.resultValue;
                }
            });
    }

    clickCheckSameId(){
        let searchInfo = {
            userId:this.f.userId.value
        };
        this.fvmsApiAuthService.checkSameId(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.checkSameId = (apiResponse.resultValue === 0);
                }
            });
    }

    clickUserPwReset(){
        let searchInfo = {
            userId:this.f.userId.value
            ,userPw:this.f.userPw.value
            ,updateUser:this.currentUserInfo.userId
        };
        this.fvmsApiAuthService.resetUserPw(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    if(apiResponse.resultValue > 0){
                        this.userPwReset = "초기화 성공";
                        return;
                    }
                }
                this.userPwReset = "초기화 실패";
            });
    }

    clickOpenModalCompanyInfo(dtgActionType:DtgActionType){
        let modalRef = this.modalService.open(
            DtgManageCompanySearchComponent
            ,{
                centered:true
                ,size: "sm"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );

        modalRef.result.then((resultModal) => {
            if(resultModal.result === "ok"){
                // console.log("clickOpenModalCompanyInfo",resultModal.companyInfo);
                if(resultModal.companyInfo.companyId !== this.f.companyId.value){
                    this.formGroup.patchValue({
                        companyId : resultModal.companyInfo.companyId
                        ,companyNm : resultModal.companyInfo.companyNm
                    });
                    let searchInfo = {
                        companyId:resultModal.companyInfo.companyId
                        ,userId:this.f.userId.value
                    };
                    this.fvmsApiDtgUserService.moveUserCompany(searchInfo)
                        .pipe(takeWhile(() => this.isContinue))
                        .subscribe(apiResponse => {
                            this.activeModal.close({
                                "result":"ok"
                            });
                        });
                }
            }
        });
    }

    clickCancel(){
        this.activeModal.close({
            "result":"cancel"
        });
    }

    clickSave(){
        this.onSubmit();
    }

    onSubmit(){
        this.submitted = true;
        // console.log("onSubmit",this.f);
        if (this.formGroup.invalid || this.checkSameId === false) {
            return;
        }

        let userInfo = {
            userId:this.f.userId.value
            ,userNm:this.f.userNm.value
            ,userPw:this.f.userPw.value
            ,companyId:this.f.companyId.value
            ,userGroupId:this.f.userGroupId.value
            ,userGroupNm:this.f.userGroupNm.value
            ,dtgDriverNm:this.f.dtgDriverNm.value
            ,dtgDriverLcsNo:this.f.dtgDriverLcsNo.value
            ,drvKotsaDriverId:this.f.drvKotsaDriverId.value
            ,userBirthDt:this.f.userBirthDt.value
            ,userHireDt:this.f.userHireDt.value
            ,dtgTeamId:this.f.dtgTeamId.value
            ,email:this.f.email.value
            ,mobile:this.f.mobile.value
            ,memo:this.f.memo.value
            ,useYn:this.f.useYn.value
            ,createUser:this.currentUserInfo.userId
            ,updateUser:this.currentUserInfo.userId
            ,dtgUnitId:this.f.dtgUnitId.value
        };
        // console.log("onSubmit",userInfo);

        this.fvmsApiDtgUserService.upsertUser(userInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    // console.log("new user id",apiResponse.resultValue.userId);
                    // 사용자 차량 운행 등록
                    // this.fvmsApiDtgUserService.upsertUserCarRunLast(userInfo)
                    //     .pipe(takeWhile(() => this.isContinue))
                    //     .subscribe(apiResponse2 => {
                    //         // console.log("new user id",apiResponse2.resultValue.userId);
                    //     });
                }

                this.activeModal.close({
                    "result":"ok"
                });
            });
        return;
    }
}
